import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { instagramListPath, 
  InstagramListUrlQueryParams, 
  InstagramListUrlSortField, 
  instagramPath, 
  InstagramPathUrlQueryParams
  } from "./urls";
import InstagramDetailsComponent from "./views/InstagramDetails"
import InstagramListComponent from "./views/InstagramList";

const InstagramList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
    const qs = parseQs(location.search.substr(1));
    const params: InstagramListUrlQueryParams = asSortParams(
        qs,
        InstagramListUrlSortField
    );
    return <InstagramListComponent params={params} />;
};

const InstagramDetails:React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: InstagramPathUrlQueryParams = qs;
  return (
    <InstagramDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const InstagramSection: React.FC=()=>{
    const intl = useIntl();

    return (
      <>
        <WindowTitle title={intl.formatMessage(sectionNames.instagram)} />
        <Switch>
          <Route exact path={instagramListPath} component={InstagramList} />
          <Route path={instagramPath(":id")} component={InstagramDetails} />
        </Switch>
      </>
    );
  };
  
  export default InstagramSection;